// Language choice (T-112). Signed in, the choice is saved on the account so that e-mails use it
// too; signed out, it is remembered on this device.

import { useQueryClient } from "@tanstack/react-query";

import { api, type Me } from "../api";
import { useToast } from "./overlay";
import { LANGUAGE_NAMES, LOCALES, isLocale, setLocale, t, useLocale } from "../i18n";

export function LanguageSelect({ signedIn, className = "" }: { signedIn: boolean; className?: string }) {
  const current = useLocale();
  const queryClient = useQueryClient();
  const toast = useToast();
  return (
    <select
      aria-label={t("account.language")}
      className={`rounded-[7px] border border-rule bg-paper px-2 py-1.5 text-sm ${className}`}
      value={current}
      onChange={async (event) => {
        const next = event.target.value;
        if (!isLocale(next)) return;
        await setLocale(next);
        if (signedIn) {
          const me = await api.post<Me>("/auth/me/locale", { locale: next });
          queryClient.setQueryData(["me"], me);
          toast(t("account.languageSaved"), "success");
        }
      }}
    >
      {LOCALES.map((code) => (
        <option key={code} value={code} lang={code}>
          {LANGUAGE_NAMES[code]}
        </option>
      ))}
    </select>
  );
}
